import { render } from "./UIcon.vue?vue&type=template&id=137df9d5"
import script from "./UIcon.vue?vue&type=script&lang=ts"
export * from "./UIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script